import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { BASE_API_URL, IS_DEV_ENV } from 'consts/appConsts';
import { CHIME_APPLICATION_TOKEN, CHIME_DEVICE_ID } from 'consts/storageConsts';

import { getValueFromStorage } from 'utils/storage/storageHelper';

export const httpLink = createHttpLink({
  uri: `${BASE_API_URL}/graphql`,
});

export const authLink = setContext((_, { headers }) => {
  const deviceId = getValueFromStorage(CHIME_DEVICE_ID);
  const chimeApplicationToken = getValueFromStorage(CHIME_APPLICATION_TOKEN);
  return {
    headers: {
      ...headers,
      Accept: '*/*',
      'Content-Type': 'application/json',
      'Chime-Client-Platform': 'web',
      'Chime-Device-UUID': deviceId,
      'Chime-Application-Token': chimeApplicationToken,
    },
  };
});

export const apolloClient = new ApolloClient({
  connectToDevTools: IS_DEV_ENV,
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
